export default {
  professionalCaptation: {
    loading: false,
    lastUpdate: null,
    data: {},
    idProfessional: null,
  },
  professionalSegmentations: {
    loading: false,
    lastUpdate: null,
    data: {},
    idProfessional: null,
  },
  professionalSegmentationsHistorical: {
    loading: false,
    lastUpdate: null,
    data: [],
    idProfessional: null,
  },
  valuationHolding: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  PJPartnership: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  customers: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  familyGroup: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  customersPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  calculator: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  captable: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  captableFees: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  controlPartnership: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  controlSummary: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  rankingCaptacao: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  mixComments: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  orcadoRealizado: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // {{NEXT}}
}
